module.exports = __webpack_public_path__ + "media/images/about__our-culture-3-5c5685f2ea0bfbb9a7d0fa5fe0fe283b.jpg";